const studentApi = {
  GETLISTBYCLASSID: 'CSVPA-China/api/student/getListByClassId', //班级里学生
  GETSTUDENTMESSAGE: 'CSVPA-China/api/student/getListByPager', //学生查询信息
  ADDSTUDENTMESSAGE: 'CSVPA-China/api/student/save', //新增学生信息
  UPDATASTUDENTMESSAGE: 'CSVPA-China/api/student/update', //编辑学生信息
  GETSTUDENTLISTALL: 'CSVPA-China/api/student/getListAll', //所有学生
  GETTEACHINGSTUDENTLIST: 'CSVPA-China/api/student/getTeachingStudentList', //老师教的学生
  SAVEENROLLMENT: 'CSVPA-China/api/enrollmentRecord/save', //学籍变动
  ENROLLMENTRECORD: 'CSVPA-China/api/enrollmentRecord/getListAllByStudentId', //学籍记录
  GETBASICGRADEBYCLASSID: 'CSVPA-China/api/student/getBasicGradeByClassId', //基础成绩
  SUBMITBASIGRADE: 'CSVPA-China/api/basiGrade/submit', //提交基础成绩
  EDITBASIGRADE: 'CSVPA-China/api/basiGrade/edit', //编辑基础成绩
  REEDITBASIGRADE: 'CSVPA-China/api/basiGrade/reedit', //重新编辑基础成绩
  GETQUIZGRADEBYCLASSID: 'CSVPA-China/api/student/getQuizGradeByClassId', //测验成绩
  SUBMITQUIZGRADE: 'CSVPA-China/api/quizGrade/submit', //提交测验成绩
  EDITQUIZGRADE: 'CSVPA-China/api/quizGrade/edit', //编辑测验成绩
  REEDITQUIZGRADE: 'CSVPA-China/api/quizGrade/reedit', //重新编辑测验成绩
  ADVISORFEEDBACK: 'CSVPA-China/api/student/getBasicFeedBackByClassId', //班主任评语
  EDITADVISORFEEDBACK: 'CSVPA-China/api/basiGradeFeedback/edit', //编辑班主任评语
  REEDITADVISORFEEDBACK: 'CSVPA-China/api/basiGradeFeedback/reedit', //重新编辑班主任评语
  SUBMITADVISORFEEDBACK: 'CSVPA-China/api/basiGradeFeedback/submit', //提交班主任评语
  GETSCOREREPORTS:
    'CSVPA-China/api/transcriptPermissions/transcriptPermissions', //获取学生成绩单
  // switchreportcard
  SWITCHCHREPORTCAR: 'CSVPA-China/api/transcriptPermissions/update',
  STUDENTPROMOTION: 'CSVPA-China/api/student/promote',
  WRITESTUDENTINFO: 'CSVPA-China/api/student/writeStudentInfo', //导出学生
  getAllStudent: 'CSVPA-China/api/student/getListByPager',
  addStudentIntoClass: 'CSVPA-China/api/roster/save', //添加学生
  deleteStudentClass: 'CSVPA-China/api/roster/delete', //删除学生
  ChangeStudentClass: 'CSVPA-China/api/roster/change', //换班学生
  getClassArrData: 'CSVPA-China/api/classes/getClassesAll' //分页查询班级
}

export default studentApi
